import React from "react";
import { AiOutlineReload } from "react-icons/ai";
import LoaderStyle from "./LoaderSgtyle";

const Loader = () => {
  return (
    <LoaderStyle>
      <AiOutlineReload />
    </LoaderStyle>
  );
};

export default Loader;
